import { useTitle } from "@/hooks/use-title.hook.ts";
import { ScoreCardEditDetailsPage } from "@/pages/recruit/scorecards/edit/components/ScoreCardEditDetailsPage.tsx";
import { ScoreCardEditQuestionsPage } from "@/pages/recruit/scorecards/edit/components/ScoreCardEditQuestionsPage.tsx";
import { ScoreCardsEditPageStep } from "@/pages/recruit/scorecards/edit/components/scorecards-edit-pages.tsx";
import { useScoreCardDetails } from "@/queries/recruit/use-scorecards.query.ts";
import { Button, FullScreenPage, Skeleton } from "@skailer-com/uikit";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";

export function ScoreCardEdit() {
  const { id, step } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data: scoreCard } = useScoreCardDetails(id ? parseInt(id) : undefined, !!id);

  useTitle(scoreCard?.title, t("common:edit"), t("scorecards:scorecard"));

  const currentStep = useMemo(() => {
    if (step) {
      return step as ScoreCardsEditPageStep;
    }
    return ScoreCardsEditPageStep.details;
  }, [step]);

  if (scoreCard) {
    if (currentStep == ScoreCardsEditPageStep.details) {
      return <ScoreCardEditDetailsPage scoreCard={scoreCard} />;
    } else if (currentStep == ScoreCardsEditPageStep.questions) {
      return <ScoreCardEditQuestionsPage scoreCard={scoreCard} />;
    }
  }

  return (
    <FullScreenPage
      title={t("scorecards:scorecards")}
      isCenterVertical={false}
      backSlot={
        <Button
          variant={"secondary"}
          size={"lg"}
          onClick={() => {
            navigate("/recruitment/scorecards");
          }}
        >
          {t("common:exit")}
        </Button>
      }
    >
      <Skeleton className={"w-full h-10"} />
    </FullScreenPage>
  );
}
